<template>
  <div>
    <v-card>
      <v-row>
        <v-col>
          <v-card-title>Bank Epf Income Tax Import</v-card-title>
        </v-col>

        <v-col
          cols="2"
          class="ma-auto"
        />

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                href="/templates/Bank Epf Income Tax.xlsx"
                color="hrissuccess"
                dark
                icon
                medium
                v-on="{ ...tooltip }"
              >
                <v-icon class="mr-1">
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <span>Bank Epf Income Tax Import Template</span>
          </v-tooltip>

          <import-payroll-bank-epf-income-tax-dialog-import />
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  export default {
    components: {
      ImportPayrollBankEpfIncomeTaxDialogImport: () => import('@/components/hris/import/payroll/bank-epf-income-tax/DialogImport'),
    },
  }
</script>
